import SpriteSymbol from "../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-sequence-editor-format-underline",
  "use": "icon-sequence-editor-format-underline-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" fill=\"none\" id=\"icon-sequence-editor-format-underline\">\n    <path d=\"M2.61719 13.9525H13.2815M11.9485 2.6216V7.28725C11.9485 9.4959 10.158 11.2864 7.94936 11.2864C5.7407 11.2864 3.95023 9.4959 3.95023 7.28725V2.6216M2.61719 1.95508H5.28327M10.6154 1.95508H13.2815\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol